/**
* Related Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Related Services component.
*/

( function( app ) {
  const COMPONENT = {

    className: 'related-services',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const groups = document.querySelectorAll( '.group' );

      const handleHover = ( group ) => {
        const heading = group.querySelector( '.related-services__heading' );
        const description = group.querySelector( '.related-services__description' );

        if ( heading && description ) {
          heading.style.transition = 'transform 300ms ease-in-out';
          description.style.transition = 'opacity 350ms ease-in-out';
          description.style.opacity = '0';

          group.addEventListener( 'mouseenter', () => {
            const descriptionHeight = description.offsetHeight;
            const transformAmount = descriptionHeight + 10;
            heading.style.transform = `translateY(-${transformAmount}px)`;
            description.style.opacity = '1';
          } );

          group.addEventListener( 'mouseleave', () => {
            heading.style.transform = 'translateY(0)';
            description.style.opacity = '0';
          } );
        }
      };

      const applyHoverEffectOnDesktop = () => {
        if ( window.innerWidth >= 1024 ) {
          groups.forEach( ( group ) => handleHover( group ) );
        } else {
          groups.forEach( ( group ) => {
            const heading = group.querySelector( '.related-services__heading' );
            const description = group.querySelector( '.related-services__description' );

            if ( heading && description ) {
              heading.style.transform = 'translateY(0)';
              description.style.opacity = '1';
              description.style.transition = 'opacity 0s';
              heading.style.transition = 'transform 0s';

              group.removeEventListener( 'mouseenter', handleHover );
              group.removeEventListener( 'mouseleave', handleHover );
            }
          } );
        }
      };

      applyHoverEffectOnDesktop();
      window.addEventListener( 'resize', applyHoverEffectOnDesktop );
    },

    finalize: function() {},
  };

  // Hooks the component into the app
  app.registerComponent( 'related-services', COMPONENT );
} )( app );
